<template>
   <div class="common-auth-wrapper">
      <div class="login-page-content">
         <div class="cmn-auth-form-wrap">
            <div class="form-heading-wrap">
               <h2 class="form-title">Welcome <span>Back</span></h2>
               <p class="form-sub-text">Enter your email & password to login your account.</p>
            </div>
            <form @submit.prevent="signIn" id="myForm" class="user">
               <div class="cmn-form-wrapper">
                  <div class="form-group">
                     <input
                        type="email"
                        name="username"
                        class="cmn-input-field form-control"
                        id="yourEmail"
                        placeholder="Email Address"
                        v-model="v$.form.email.$model"
                        autofocus
                     />
                     <div
                        class="input-errors"
                        v-for="(error, index) of v$.form.email.$errors"
                        :key="index"
                     >
                        <div class="error-msg">{{ error.$message }}</div>
                     </div>
                  </div>
                  <div class="form-group">
                     <input
                        type="password"
                        name="password"
                        class="cmn-input-field form-control"
                        id="yourPassword"
                        v-model="v$.form.password.$model"
                        placeholder="password"
                     />
                     <div
                        class="input-errors"
                        v-for="(error, index) of v$.form.password.$errors"
                        :key="index"
                     >
                        <div class="error-msg">{{ error.$message }}</div>
                     </div>
                  </div>
                  <div class="custom-control custom-checkbox">
                     <input
                        type="checkbox"
                        name="remember"
                        class="custom-control-input"
                        id="rememberMe"
                        checked
                     />
                     <label class="custom-control-label" for="rememberMe"
                        >Remember Me</label
                     >
                  </div>
                  <button
                     type="submit"
                     class="btn cmn-auth-btn"
                     v-on:click="signIn"
                     :disabled="v$.form.$invalid"
                     v-if="loginLoader === 1"
                  >
                     <span class="auth-btn-wrap">Sign In</span>
                     <span class="auth-arrow">
                        <img src="../assets/images/auth-images/btn-icon.svg" alt="arrow icon"/>
                     </span>
                  </button>
                  <button class="btn cmn-auth-btn loading-btn" :disabled="v$.form.$invalid" v-else>
                     <span
                     class="spinner-border mr-2 spinner-border-sm"
                     role="status"
                     aria-hidden="true"
                     ></span>
                     Loading...
                  </button>
               </div>
            </form>
         </div>
         <div class="auth-form-content">
            <a href="/" class="mini-logo-link">
               <img src="../assets/images/auth-images/mini-logo.svg" alt="mini logo"/>
            </a>
            <h1 class="auth-title">Welcome to MDrive.</h1>
            <p class="auth-sub-text">Let's get you all set up so you can verify your personal account and begin setting up your profile</p>
         </div>
         <!-- <div class="sign-user-card">
            <img
               src="../assets/images/logo.png"
               class="img-fluid rounded-normal light-logo logo"
               alt="logo"
            />
            
         </div> -->
      </div>
   </div>
   <div class="auth-footer">
      <div class="foot-logo">
         <img src="../assets/images/auth-images/footer-logo-init.svg" alt="foot logo"/>
      </div>
      <div class="copyright-wrap">
         <h6 class="copyright-title"><span>M</span>Drive</h6>
         <span class="copyright-text">©Copyright MDrive {{currentYear}}</span>
      </div>
   </div>
</template>
<script>
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import { required, email, helpers, minLength } from "@vuelidate/validators";
import { startLoader, finishLoader } from "../utils/helper.js";
export function validName(name) {
  let validNamePattern = new RegExp("^[a-zA-Z]+(?:[-'\\s][a-zA-Z]+)*$");
  if (validNamePattern.test(name)) {
    return true;
  }
  return false;
}
export default {
  name: "LoginPage",
  mounted() {
    this.$store.state.isLogin = 0;
    let email = localStorage.getItem("mDriveEmail");
    let password = localStorage.getItem("mDrivePassword");
    if (email) {
      this.form.email = email;
      this.form.password = password;
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      loginLoader: 1,
      errorMessage: "",
      errorRes: "",
      currentYear: new Date().getFullYear(),
      form: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    startLoader,
    finishLoader,
    async signIn() {
      this.startLoader();
      this.loginLoader = 2;
      await axios
        .post(process.env.VUE_APP_API_URL + "login", {
          email: this.form.email,
          password: this.form.password,
        })
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == "success") {
            localStorage.setItem("mDrivetoken", resp.data.data.token);
            this.$store.state.user.accessToken = resp.data.data.token;
            this.$store.state.user.userInfo = resp.data.data.user;
            this.$store.state.user.roleId = resp.data.data.user.role;
            this.$store.state.user.role_name = resp.data.data.user.role_name;
            this.$store.state.isActiveToken = 1;
            this.loginLoader = 1;
            this.$store.state.attemptLogin = 2;
            const rememberMe = document.getElementById("rememberMe");
            if (rememberMe.checked) {
              localStorage.setItem("mDriveEmail", this.form.email);
              localStorage.setItem("mDrivePassword", this.form.password);
            } else {
              localStorage.removeItem("mDriveEmail");
              localStorage.removeItem("mDrivePassword");
            }
            this.$store.state.isLogin = 1;
            this.finishLoader();
            this.$router.push({ name: "Home" });
          } else if (resp.status == 200 && resp.data.status == "failure") {
            this.loginLoader = 1;
            this.$toast.error(resp.data.message);
          } else if (resp.status == 401) {
            this.loginLoader = 1;
            this.$toast.error(resp.data.message);
          }
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          console.log("response", error.response.status);
          console.log("message", error.response.data.message);
          this.errorRes = error.response.data.message;
        });
    },
  },
  validations() {
    return {
      form: {
        email: {
          required: helpers.withMessage("Please enter email id", required),
          // min: minLength(6)
          email,
        },
        password: {
          required: helpers.withMessage("Please enter password", required),
          min: minLength(6),
        },
      },
    };
  },
};
</script>